/**
 * Kanban Board Card Component
 * Displays kanban board information from MCP tool results
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './EntityCard.css';

interface KanbanBoardStats {
  total_items: number;
  tickets: number;
  leads: number;
}

interface KanbanBoard {
  id: string;
  title: string;
  slug: string;
  ticket_count?: number;
  stats?: KanbanBoardStats;
}

interface KanbanBoardCardProps {
  board: KanbanBoard;
  compact?: boolean;
}

export const KanbanBoardCard: React.FC<KanbanBoardCardProps> = ({
  board,
  compact = false,
}) => {
  return (
    <div
      className={`kanban-board-card entity-card ${compact ? 'compact' : ''}`}
    >
      <div className="entity-card-header">
        <h4 className="entity-card-title">📋 {board.title}</h4>
        {board.ticket_count !== undefined && (
          <span className="board-ticket-badge">
            {board.ticket_count} tiketa
          </span>
        )}
      </div>

      {!compact && (
        <div className="entity-card-body">
          <div className="entity-card-field">
            <span className="field-label">Slug:</span>
            <code className="field-value">{board.slug}</code>
          </div>

          {board.stats && (
            <div className="board-stats">
              <div className="stat-item">
                <span className="stat-label">Total Items:</span>
                <span className="stat-value">{board.stats.total_items}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Tickets:</span>
                <span className="stat-value">{board.stats.tickets}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Leads:</span>
                <span className="stat-value">{board.stats.leads}</span>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="entity-card-footer">
        <Link to={`/apps/kanban/${board.slug}`} className="entity-card-link">
          Otvori Board →
        </Link>
      </div>
    </div>
  );
};
